module.exports = __webpack_public_path__ + "img/career-01.f72b799b.jpg";